// @ts-ignore: side-effect import of SCSS handled by bundler
import "@style/style.scss";

import { MainMenu } from "@ts/MainMenu";
import { Page } from "@ts/Page";
import { initGlobalErrorHandler } from "@ts/core/globalError";

export async function entersite(pagename:string) : Promise<void> {
    initGlobalErrorHandler();
    
    const menu = new MainMenu;
    await menu.load();

    const page = new Page;
    await page.load(pagename);
}

// Gör funktionen global så PHP-HTML kan anropa den
// @ts-ignore
window.entersite = entersite; 
